import Config from "../../env/config";
// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from "react";
// eslint-disable-next-line no-unused-vars
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LazyImage from "../../Components/LazyImage/LazyImage";
import "./SectionFour.scss";
import { useLang } from "../../Utility/hooks/useLang";

const SectionFour = () => {
  const CDN_URL = Config.CDN_URL;
  // const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const { lang, setLang } = useLang();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);
  return (
    <div className="SectionFourContent">
      <div className="container">
        <div className="ourpartners">
          {lang === "ar" ?
            <h4 className="partTitle dirRtl">شركاؤنا في التأمين</h4> :
            <h4 className="partTitle">{t("HM_INSURANCE_PARTNER_TXT")}</h4>
          }
          {lang === "ar" ?
            <p className="prSubTitle dirRtl">المزيد من التوفير والمزيد من الراحة لك!</p> :
            <p className="prSubTitle">{t("HM_MORE")} {t("HM_SAVINGS")} {t("HM_MORE_CONVENIENCE_TXT")}</p>
          }
          <div className="partnerLogos">
            <div className="prtLogos">
              <LazyImage src={`${CDN_URL}takafuloman_logo_img1.webp`} width={180} height={60} loading="lazy" alt="Takaful Oman Insurance" title="Takaful Oman Insurance" />
            </div>
            <div className="prtLogos">
              <LazyImage src={`${CDN_URL}oqic_logo_img.webp`} width={120} height={60} loading="lazy" alt="Oqic Insurance" title="Oqic Insurance" />
            </div>
            <div className="prtLogos">
              <LazyImage src={`${CDN_URL}gig_logo_img.webp`} width={120} height={60} loading="lazy" alt="Gig" title="Gig" />
            </div>
            <div className="prtLogos">
              <LazyImage src={`${CDN_URL}falcon_insurance.webp`} width={180} height={60} loading="lazy" alt="Arabia Insurance" title="Arabia Insurance" />
            </div>
            <div className="prtLogos">
              <LazyImage src={`${CDN_URL}dhofar_insu_logo_img1.webp`} width={180} height={60} loading="lazy" alt="Dhofar" title="Dhofar" className="dhoFar" />
            </div>
            <div className="prtLogos">
              <LazyImage src={`${CDN_URL}mic_logo_img.webp`} width={120} height={60} loading="lazy" alt="Mic" title="Mic" />
            </div>
            <div className="prtLogos">
              <LazyImage src={`${CDN_URL}new_india_logo_img_01.webp`} width={180} height={60} loading="lazy" alt="The New India Assurance Co. Ltd" title="The New India Assurance Co. Ltd" />
            </div>
            <div className="prtLogos">
              <LazyImage src={`${CDN_URL}orient_logo_img.webp`} width={180} height={60} loading="lazy" alt="Orient Insurance PJSC" title="Orient Insurance" />
            </div>
            <div className="prtLogos">
              <LazyImage src={`${CDN_URL}liva_logo_img.webp`} width={180} height={60} loading="lazy" alt="Liva" title="Liva" />
            </div>
            <div className="prtLogos">
              <LazyImage src={`${CDN_URL}madina_logo.webp`} width={180} height={60} loading="lazy" alt="Al Madina Takaful" title="Al Madina Takaful" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionFour;